import { useState, useEffect } from "react";
import Navbar from "../../components/layout/navbar"
import useRequest from "../../components/hooks/use-request";
import Button from "../../components/button";
import { Plus } from "lucide-react";
import RequisitionCard from "./requisition-card";
import RequisitionTable from "./requisition";
import AddRequisitionDialog from "../../components/requisition/add-requisition-dialog";

interface ProfileData {
    username: string;
    email: string;
    phone: string;
    address: string;
    lastLogin: string;
}

interface MetricsData {
    totalApprovedRequisitions: number;
    totalPendingRequisitions: number;
    totalRejectedRequisitions: number;
    totalRequisitions: number
}


const Requisition = () => {
    const [profile, setProfile] = useState<ProfileData | null>(null);
    const [metrics, setMetrics] = useState<MetricsData | null>(null);
    const [requisition, setRequisition] = useState<[]>([]);
    const [requisitionModal, setRequisitionModal] = useState(false)


    const userToken = localStorage.getItem("token");
    
    const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getMetrics } = useRequest("/purchase-requisition/metrics", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

     const { makeRequest: getPromotions } = useRequest("/purchase-requisition", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

    useEffect(() => {
        const fetchProfile = async () => {
          const [response] = await getProfile();
          if (response.status) {
            setProfile(response.data?.user);
          }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchMetrics = async () => {
          const [response] = await getMetrics();
          if (response.status) {
            setMetrics(response.data);
          }
        };
        fetchMetrics();
    }, []);

    useEffect(() => {
        const fetchSuppliers = async () => {
          const [response] = await getPromotions();
          if (response.status) {
            setRequisition(response.data?.requisitions);
          }
        };
        fetchSuppliers();
      }, []);

      function closeDiscountModal() {
        setRequisitionModal(false);
      }

      function openRequisitionModal() {
        setRequisitionModal(true);
      }


    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar profile={profile as ProfileData} />

            <main className="flex-1 container mx-auto py-6">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
                    <div className="mb-4 sm:mb-0">
                        <h1 className="text-[30px] font-extrabold text-black">
                            Purchase Requisitions
                        </h1>
                        <p className="text-[#676767] text-[18px] font-normal">
                            Create and manage purchase Requisitions for inventory restocking
                        </p>
                    </div>
                    <div className="flex gap-2">
                        <button className="rounded-full border px-4 py-1">Export</button>

                        <Button
                            size="lg"
                            variant="primary"
                            type="button"
                            className="font-normal md:mt-0 mt-6"
                            onClick={openRequisitionModal}
                        >
                        <Plus />Create Purchase Requisition
                        </Button>
                    </div>
                </div>

                {metrics && <RequisitionCard metrics={metrics} />}
                <RequisitionTable data={requisition}/>

            </main>

            <AddRequisitionDialog
                isVisible={requisitionModal}
                onClose = {closeDiscountModal}
                requisition={requisition}
            />
        </div> 
    );
}
 
export default Requisition;